import { useEffect, useState } from "react";
import { useResponsive } from "@poriyaalar/custom-hooks";
import { useNavigate } from "react-router";
import { ThreeDots } from "react-loader-spinner";
import { useTheme } from "@mui/material";

export default function MutateLoader() {
  const [exceed, setExceed] = useState(false);
  const { isMobile, isTab } = useResponsive();
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      setExceed(true);
    }, 5000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const handleNavigate = () => {
    navigate("/", { replace: true });
    setExceed(false);
  };
  const theme = useTheme();
  const PRIMARY = theme.palette.primary.main;
  return (
    <div className="flex items-center justify-center h-screen w-full bg-white">
      <div className="flex flex-col items-center">
        {!exceed && (
          <ThreeDots
            height="150"
            width="150"
            radius="9"
            color={PRIMARY}
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        )}
        {exceed && (
          <div className="flex flex-col items-center">
            <div className="text-2xl">Took too long to respond</div>
            <button
              className={`${
                isTab ? "text-base" : isMobile ? "text-sm" : "text-xl"
              } bg-primary-300 text-white px-8 py-5 rounded-md mt-4`}
              onClick={() => handleNavigate()}
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
